import React from "react";
import PTForm from "../pt-portal/PTForm";

const PTCreateProfile = () => {
  return (
    <div style={{ padding: 24 }}>
      <h2>📝 Tạo hồ sơ PT của tôi</h2>
      <PTForm />
    </div>
  );
};

export default PTCreateProfile;
